export const getReserve = 'cls_res_cki/fnc_csu_res_cki';
export const getClient = 'cls_res_cki/fnc_csu_res_cli';
export const getCommuneList = 'cls_res_cki/fnc_csu_lst_com';
export const getVehicle = 'cls_res_cki/fnc_csu_cki_veh';
export const sendCheckin1Data = 'cls_res_cki/grb_cki_pss_uno';
export const uploadExampleFile = 'cls_res_cki/fnc_upl_fle';
export const sendCheckin2Data = 'cls_res_cki/sva_grb_cki_fnl';

export default {};